import createReducer from 'reducers/createReducer';

import {ItemPayment} from 'actions/actionTypes';
import {ArrayConcat} from "../../utils/functions";

const INITIAL_STATE = {
    searchFilter: {
        page: 1,
        pageSize: 20,
    },
    itemPaymentHistoryList: {
        maxPage: 0,
        totalCount: 0,
        list: [],
    },
    paymentInfoData: {
        paymentMethodType: '',
        itemId: '',
        quantity: 1,
        totalPrice: '',
    },
    paymentGatewayRequest: {
        isOpen: false,
        script: '',
        html: '',
    },
    error: {
        triggered: false,
        message: '',
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    // 아이템 결제 팝업 노출 여부
    [ItemPayment.CHANGE_PAYMENT_GATEWAY_REQUEST_OPEN]: (state, action) => (state.paymentGatewayRequest.isOpen = action.payload),

    // 아이템 결제 방식(신용카드,계좌이체)
    [ItemPayment.ADD_ITEM_PAYMENT_METHOD_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;

        state.paymentInfoData.paymentMethodType = action.payload.type;
        state.paymentInfoData.totalPrice = parseFloat(action.payload.totalPrice);
        state.paymentInfoData.itemId = action.payload.itemId;
        console.log("ADD_ITEM_PAYMENT_METHOD_REQUEST qqq :", action.payload.quantity);
        state.paymentInfoData.quantity = action.payload.quantity;
    },
    [ItemPayment.ADD_ITEM_PAYMENT_METHOD_SUCCESS]: (state, action) => {
        state.paymentGatewayRequest.script = action.payload.script;
        state.paymentGatewayRequest.html = action.payload.html;
    },
    [ItemPayment.ADD_ITEM_PAYMENT_METHOD_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    // 아이템 결제 script
    [ItemPayment.ITEM_PAYMENT_SUCCESS] : (state,action) => {
        state.paymentGatewayRequest = INITIAL_STATE.paymentGatewayRequest;
    },

    // 검색 필터
    [ItemPayment.CHANGE_ITEM_PAYMENT_HISTORY_SEARCH_FILTER]: (state, action) => {
        if (action.payload.type === 'checkbox') {
            state.searchFilter[action.payload.name] = ArrayConcat(
                Array.from(state.searchFilter[action.payload.name]),
                action.payload.value
            );
        } else {
            state.searchFilter[action.payload.name] = action.payload.value;
        }
    },

    // 아이템 구매 내역 조회
    [ItemPayment.LOAD_ITEM_PAYMENT_HISTORY_LIST_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [ItemPayment.LOAD_ITEM_PAYMENT_HISTORY_LIST_SUCCESS]: (state, action) => {
        state.searchFilter.page = action.payload.currentPage;
        state.itemPaymentHistoryList.maxPage = action.payload.maxPage;
        state.itemPaymentHistoryList.totalCount = action.payload.totalCount;
        state.itemPaymentHistoryList.list = action.payload.list;
    },
    [ItemPayment.LOAD_ITEM_PAYMENT_HISTORY_LIST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },
});

export default reducer;
